/**
 * Compiles a sorting layout into the options the list header's sort menu takes.
 *
 * A layout entry is `{ key, label, isDefault }` like every other surface's; the menu and
 * `applySorting` read the sorted column as `value`.
 *
 * @param {Array} layout - The sortable columns, in order.
 *
 * @returns {Array}
 */
export const resolveSorting = (layout) =>
  (layout ?? []).map(({ key, label, isDefault }) => ({
    value: key,
    label,
    ...(isDefault ? { isDefault } : {}),
  }));

export default resolveSorting;
